// imports external libraries
import { motion, MotionProps } from 'motion/react';

export const MotionSlideUpPositionIn = (props: MotionProps) => (
  <motion.div
    layout={props.layout}
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: 10 }}
    transition={{
      duration: 0.3,
      opacity: { duration: 0.2 },
      layout: { type: 'spring', stiffness: 300, damping: 30 }
    }}
    {...props}
  >
    {props.children}
  </motion.div>
);

export const MotionGrowDown = (props: MotionProps) => (
  <motion.div
    layout={props.layout}
    initial={{ opacity: 0, height: 0 }}
    animate={{ opacity: 1, height: 'auto' }}
    exit={{ opacity: 0, height: 0 }}
    transition={{
      duration: 0.3,
      ease: 'easeOut',
      layout: { type: 'spring', stiffness: 300, damping: 30 }
    }}
    {...props}
  >
    {props.children}
  </motion.div>
);
